import { FC } from 'react'

import { useWallet } from '@aptos-labs/wallet-adapter-react'

import { ButtonGradient } from 'components/ButtonGradient'

import NotClaimDescription from '../NotClaimDescription'

import s from './s.module.scss'

export const IsNotClaim: FC = () => {
  const { disconnect } = useWallet()

  const onDisconnect = () => {
    disconnect()
  }

  return (
    <div className={s.withoutClaim}>
      <ButtonGradient className={s.disconnectWallet} onClick={onDisconnect}>
        Disconnect
      </ButtonGradient>
      <NotClaimDescription />
    </div>
  )
}
